import axios from 'axios'
import qs from 'qs'
import host from './host'
// const HOST = host.ydhxgApi + ':8443';

// axios 配置
axios.defaults.timeout = 10000;
// axios.defaults.baseURL = HOST;
axios.defaults.responseType= 'json';
// axios.defaults.headers['Access-Control-Allow-Origin'] ='*';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}
// POST传参序列化
axios.interceptors.request.use((config) => {
  removePending(config); //在一个ajax发送前执行一下取消操作
  config.cancelToken = new cancelToken((c)=>{
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({ u: config.url + '&' + config.method, f: c });
  });

  // console.log(config.headers)
  if(config.method === 'post' && config.headers.post['Content-Type'] == 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
// 拦截器
axios.interceptors.response.use(
  response => {  //成功请求到数据
    // console.log(response)
    //这里根据后端提供的数据进行对应的处理
    return response;
  },
  error => {  //响应错误处理
    console.log(error);
    console.log(JSON.stringify(error));
    // alert('请求超时');
    return Promise.reject(error)
  }
)
export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js